// src/components/header.jsx

import React from 'react';
import PopcornIcon from '../images/popcorn.svg'; // Direct import
import { NavLink, useNavigate, Link } from 'react-router-dom';
import './Header.css';
import { useSearch } from '../context/SearchContext';
import SearchBar from './SearchBar';

function Header() {
  const navigate = useNavigate();
  const { searchQuery, setSearchQuery, setSearchField } = useSearch();

  const handleSearch = ({ query, field }) => {
    setSearchQuery(query);
    setSearchField(field);
    navigate('/');
  };

  return (
    <header className="header">
      <div className="header-content">
        <div className="left-group">
          <h1 className="logo">
            <Link to="/" aria-label="Go to home" className="logo-link">
              <img src={PopcornIcon} alt="Popcorn Icon" className="header-icon" />
              <span>MovieMate</span>
            </Link>
          </h1>
          <nav className="navbar">
            <NavLink to="/" className={({ isActive }) => (isActive ? 'active' : '')} end>
              Home
            </NavLink>
            <NavLink to="/boxoffice" className={({ isActive }) => (isActive ? 'active' : '')}>
              Box Office
            </NavLink>
            <NavLink to="/upcoming" className={({ isActive }) => (isActive ? 'active' : '')}>
              Upcoming
            </NavLink>
            <NavLink to="/news" className={({ isActive }) => (isActive ? 'active' : '')}>
              News
            </NavLink>
          </nav>
        </div>
        <div className="search-bar">
          <SearchBar
            onSearch={handleSearch}
            value={searchQuery}
            onClear={() => setSearchQuery('')}
          />
        </div>
      </div>
    </header>

  );
}

export default React.memo(Header);
